import { Box, Center, Heading, Text, VStack, IconButton, Grid, GridItem, Flex, HStack } from "@chakra-ui/react"
import { useAppDispatch, useAppSelector } from "lib/redux"
import { FC, useEffect } from "react";
import { getPackBio, selectBio } from "./creatorCardSlice"
import { CreatorCardSocial } from "./creatorCardSocial";
import { CreatorCardContact } from "./creatorCardContact";
import { BiHide } from '@react-icons/all-files/bi/BiHide';
import { BiShow } from '@react-icons/all-files/bi/BiShow';
import { GrEdit } from '@react-icons/all-files/gr/GrEdit';
import { useLoggedinUser, usePack } from "lib/hooks";
import { Avatar } from "components";
import { baseRESTUrl, isOwner, isPreviewingPack } from "lib/utils";
import { packsClient } from "lib/clients";
import { useRouter } from "next/router";
import { usePackContext } from "domains/pack";

// TODO: This is temp and should be in theme as a custom component
const borderHoriz = '1px solid #e2e3e7';
const borderVert = '1px solid #EFEFEF'

export const CreatorCard: FC = () => {
  const dispatch = useAppDispatch();
  const bio = useAppSelector(selectBio);
  const { packId } = usePackContext();
  const { data, mutate } = usePack(packId);
  const { push } = useRouter();
  const { data: user } = useLoggedinUser();
  const { pathname } = useRouter();

  const toggle = async (): Promise<void> => {
    try {
      await packsClient.updatePack(data?.id, { show_bio: !data.show_bio });
      await mutate();
    } catch (err) {
      if (err?.response?.status === 401) {
        await push('/packs');
        return;
      }
    }
  }

  useEffect(() => {
    if (!data?.id || !data?.id.length || !data?.show_bio) {
      return;
    }

    (async() => await dispatch(getPackBio(data.id)))();
  }, [dispatch, data?.id, data?.show_bio]);


  const edit = () => {
    window.open('/account/edit-bio', '_blank');
  }

  const isPreview = isPreviewingPack(pathname)

  if (!data?.show_bio && (!isOwner(data, user) || isPreview)) {
    return null;
  }

  if (!data?.show_bio && isOwner(data, user)) {
    return (
      <Box className="pack__creator-card--hidden" borderTop={borderHoriz} borderBottom={borderHoriz} onClick={toggle}>
        <Grid autoFlow="column" justifyContent="space-between" alignItems="center">
          <GridItem>
            <Flex alignItems="center">
              <BiShow size={25} />
              <Box className="pack__creator-card--hidden__message">
                Click to reveal bio card
              </Box>
            </Flex>
          </GridItem>
          <GridItem className="pack__creator-card--hidden__comfort-message">Only visible to you</GridItem>
        </Grid>
      </Box>
    )
  }

  return (
    <Box className={isOwner(data, user) && !isPreview ? 'pack__creator-card' : 'pack__creator-card--non-admin'} borderTop={borderHoriz} borderBottom={borderHoriz}>
      <Center>
        <Box padding="0 30px" margin="30px 0" minWidth="315px" maxWidth="400px"  borderLeft={borderVert} borderRight={borderVert} >
          <Center>
            <VStack spacing="15px" width="100%">
              <Box mt={"-60px"}>
                <Avatar
                  size={"lg"}
                  data={{
                    name: bio.name,
                    src: data.user.has_avatar ? `${baseRESTUrl()}/v1/users/${data.user.id}/avatar` : null,
                  }}
                  border={"3px solid"}
                  borderColor={"white"}
                  pd={"5px"}
                />
              </Box>

              {bio.name && <Heading as="h6" size="lg">{bio.name}</Heading>}
              {bio.description && <Text size="md" textAlign="center" variant="secondary">{bio.description}</Text>}
              
              <CreatorCardSocial />
              <CreatorCardContact />

              {bio.website && (
                <Text>
                  <a href={bio.website} target="_blank" rel="noopener noreferrer" title="Personal website">
                    {bio.website}
                  </a>
                </Text>
              )}
            </VStack>
          </Center>
        </Box>
      </Center>
      <Box className="pack__creator-card__controls">
        <HStack spacing="10px">
          <IconButton aria-label="edit creator card" icon={<GrEdit />} onClick={edit} />
          <IconButton aria-label="hide creator card" icon={<BiHide />} onClick={toggle} />
        </HStack>
      </Box>
    </Box>
  )
}
